import { ModalSetting } from "@/modules/modals/viewmodels/ModalSetting";

// state
export const state = {
  modals: [],
};

export const getters = {
  modals: (state) => {
    return state.modals;
  },
  getCurrent: (state) => {
    if (state.modals[0] !== null && state.modals[0] !== undefined) {
      return state.modals[0];
    }
    return null;
  },
};

// mutations
export const mutations = {
  // Add new modal to the list
  add: (state, value) => {
    state.modals.push(new ModalSetting(value));
    return state.modals;
  },
  // Remove the file element
  closeModal: (state) => {
    if (state.modals.length > 0) {
      state.modals.splice(0, 1);
    }
    return state.modals;
  },
};

// actions

export const actions = {
  /**
   * Open a new Modal
   * @param {*} param0
   * @param {*} ModalSetting
   */
  add({ commit }, payload) {
    commit("add", payload);
  },
  /**
   * Close the current modal
   * @param {*} param0
   * @param {*} payload
   */
  close({ commit }, payload) {
    commit("closeModal", payload);
  },
};
